export default {
      id: "reefer_fish-usage",
      viewBox: "0 0 33 15",
      url: __webpack_public_path__ + "img/icons.svg#reefer_fish",
      toString: function () {
        return this.url;
      }
    }